export default {
  init() {
    // JavaScript to be fired on the home page
    $('#news-1').addClass('col-6 col-3');
    $('#news-2').addClass('col-3');
    $('#news-3').addClass('col-3');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    /* $('.news-block').on('mouseenter', function() {
      jQuery('.news-block').removeClass('col-6');
      jQuery(this).addClass('col-6');
    }); */
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js